module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f074ff_banner_800x600.3eb990d7.png";